export default [
    {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    {
        id: 2,
        'name_ca': 'Entitats de crèdit de capital públic estatal',
        'name_en': 'State public credit institutions',
        'name_es': 'Entidades de crédito de capital público estatal'
    },
    {
        id: 3,
        'name_ca': 'Bancs privats',
        'name_en': 'Private banks',
        'name_es': 'Bancos privados'
    },
    {
        id: 4,
        'name_ca': 'Caixes d\'estalvi',
        'name_en': 'Savings banks',
        'name_es': 'Cajas de ahorro'
    },
    {
        id: 5,
        'name_ca': 'Cooperatives de crèdit',
        'name_en': 'Credit unions',
        'name_es': 'Cooperativas de crédito'
    },
    {
        id: 6,
        'name_ca': 'Societats de crèdit hipotecari',
        'name_en': 'Mortgage companies',
        'name_es': 'Sociedades de crédito hipotecario'
    },
    {
        id: 7,
        'name_ca': 'Societats d\'arrendament financer',
        'name_en': 'Leasing companies',
        'name_es': 'Sociedades de arrendamiento financiero'
    },
    {
        id: 8,
        'name_ca': 'Entitats de crèdit de capital públic estatal',
        'name_en': 'State public credit institutions',
        'name_es': 'Entidades de crédito de capital público estatal'
    },
    {
        id: 9,
        'name_ca': 'Altres entitats de crèdit',
        'name_en': 'Other credit institutions',
        'name_es': 'Otras entidades de crédito'
    },
    {
        id: 10,
        'name_ca': 'Entitats asseguradores',
        'name_en': 'Insurance companies',
        'name_es': 'Entidades aseguradoras'
    },
    {
        id: 11,
        'name_ca': 'Administracions i organismes públics',
        'name_en': 'Public administrations and institutions',
        'name_es': 'Administraciones y organismos públicos'
    }
]



// WEBPACK FOOTER //
// ./src/options/petitioner_types.js